import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface statsInfo {
    epg_id: string;
    name: string;
    project_count: number;
}

export interface StatsState {
    channels: statsInfo[];
}

const initialState: StatsState = {
    channels: []
};

export const statsSlice = createSlice({
    name: 'stats',
    initialState,
    reducers: {
        setStats(state, action: PayloadAction<statsInfo[]>) {
            state.channels = action.payload;
        }
    }
});

export const { setStats } = statsSlice.actions;
export default statsSlice.reducer;